// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.connector_dialog--action {\r\n  background: #f9f9f9;\r\n  padding: 18px;\n}\r\n", ""]);
// Exports
module.exports = exports;
